/* eslint-disable react/display-name */
import Initials from 'components/Initials';
import React, { useState } from 'react';
import { SettingsIcon } from 'components/icons';
import { useHistory, useLocation } from 'react-router-dom';
import Dropdown from 'components/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import classname from 'classname';
import { SETTINGS } from 'router/routes';
import { publicPaths } from 'libs';
import { setActiveDropDown } from 'store/actions/dropdown';
import MenuItem from './menuitem';
import useSideBarData from './sidebardata';
import styles from './sidebar.module.scss';

const SideBar = React.forwardRef(
  ({ menuActive, setMenuActive, setupComplete }, ref) => {
    const [showGroup, setShowGroup] = React.useState(false);
    const history = useHistory();

    const user = useSelector((state) => state.common.user);

    const location = useLocation();
    const { pathname } = location;
    const [, path] = pathname.split('/');
    const pathWithSlash = `/${path}`;
    const { businessName } = user;
    const { role } = useSelector((state) => state.common?.user?.merchantUser);
    const { expandedId } = useSelector((state) => state.dropdown);
    const dispatch = useDispatch();
    const sidebardata = useSideBarData();

    const hideSideBar = (pathname, isExternal = false) => {
      setMenuActive(false);
      if (!isExternal && !setupComplete && !publicPaths.has(pathname)) return;

      if (isExternal) {
        window.open(pathname, '_blank');
        return;
      }
      history.push(pathname || '/');
    };

    const shouldBeDisabled = (route, isExternal = false) => {
      if (publicPaths.has(route) || isExternal) {
        return false;
      }
      return !setupComplete;
    };
    return (
      <div
        className={`${styles.sidebar} ${menuActive ? styles.active : ''}`}
        ref={ref}
      >
        <div className={styles.sidebartop}>
          <Dropdown
            isOpen={showGroup}
            setIsOpen={setShowGroup}
            header={
              <div className={styles.switch}>
                <div className={styles.initialsgroup}>
                  <Initials
                    initials={businessName && businessName.substring(0, 2)}
                  />
                  <p className={styles.initialsgrouptext}>
                    {user.businessName}
                  </p>
                </div>
                {/* <CaretDownIcon /> */}
              </div>
            }
          >
            {/* <WorkSpaceDropDown /> */}
          </Dropdown>
        </div>
        <div className={styles.sidebarbody}>
          <div className={styles.sidebaritems} data-testid="nav-buttons">
            {sidebardata.map((item) => (
              <MenuItem
                {...item}
                onClick={hideSideBar}
                pathWithSlash={pathWithSlash}
                disabled={shouldBeDisabled(item.path, item.isExternal)}
                key={item.id}
                expandedId={expandedId}
                setExpandedId={(value) => dispatch(setActiveDropDown(value))}
                pathname={pathname}
              />
            ))}
          </div>
          <div className={styles.sidebaritemsfooter}>
            <MenuItem
              onClick={() => hideSideBar(SETTINGS)}
              pathWithSlash={pathWithSlash}
              disabled={shouldBeDisabled(SETTINGS)}
              name="Settings"
              path={SETTINGS}
              icon={<SettingsIcon />}
              expandedId={expandedId}
              setExpandedId={(value) => dispatch(setActiveDropDown(value))}
              show
            />
          </div>
        </div>
      </div>
    );
  },
);

export default SideBar;
